"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var phone = 480;
exports.phone = phone;
var tablet = 768;
exports.tablet = tablet;
var small = 1024;
exports.small = small;
var medium = 991;
exports.medium = medium;
var large = 1300;
exports.large = large;
var nav = 60;
exports.nav = nav;
var smallNav = 45;
exports.smallNav = smallNav;
exports.ipadHeight = 1024;
exports.ipadWidth = tablet;
exports.iphoneStandardW = 375;
exports.iphoneStandardH = 667;
exports.iphoneWidth = 375;
exports.iphoneHeight = 812;
exports.iphoneWidthPlus = 414;
exports.iphoneHeightPlus = 736;
var ipadInLandscape = "only screen and (max-width: " + exports.ipadHeight + "px) and (max-height: " + exports.ipadWidth + "px)";
var ipadInPortrait = "only screen and (max-width: " + exports.ipadWidth + "px) and (max-height: " + exports.ipadHeight + "px)";
var iphoneInPortrait = "only screen and (max-width: " + exports.iphoneWidth + "px)  and (max-height: " + exports.iphoneHeight + "px)";
var iphoneStandardPortrait = "only screen and (max-width: " + exports.iphoneStandardW + "px)  and (max-height: " + exports.iphoneStandardH + "px)";
var iphonePlusPortrait = "only screen and (max-width: " + exports.iphoneWidthPlus + "px)  and (max-height: " + exports.iphoneHeightPlus + "px)";
var iphone = {
    portrait: iphoneInPortrait,
    landscape: ipadInLandscape,
    width: exports.iphoneWidth,
    height: exports.iphoneHeight,
    standard: {
        portrait: iphoneStandardPortrait
    },
    plus: {
        portrait: iphonePlusPortrait,
        width: exports.iphoneWidthPlus
    }
};
exports.iphone = iphone;
var ipad = {
    landscape: ipadInLandscape,
    portrait: ipadInPortrait,
    width: exports.ipadWidth,
    height: exports.ipadHeight
};
exports.ipad = ipad;
//# sourceMappingURL=media-queries.js.map